import React, { useRef, useEffect, useState } from "react";
import configData from "../../../temp/config";
import OCIcon from "../../ContentBlock/images/ovu_header_icon.png";
import "../links-home.css";
import Dropdown from "react-bootstrap/Dropdown";

// Routes require a language prefix; 'en' matches the default used in Links.js.
const withLang = (href) =>
  /^([a-z]+:)?\/\//i.test(href) || /^\/[a-z]{2}(-[a-z]{2})?(\/|$)/i.test(href)
    ? href
    : `/en${href.startsWith("/") ? "" : "/"}${href}`;

const LinksHome = (props) => {
  const [links, setLinks] = useState([]);
  useEffect(() => {
    if (props.linkdetails) {
      setLinks(props.linkdetails);
    }
  }, []);

  // set link details
  const setLinkDetails = (item, link) => {
    // Match the route patterns: "xx" or "xx-XX".
    const [lang, region] = item.fields["Regional Iso Code"].value.split("-");
    const prefix = region
      ? `${lang.toLowerCase()}-${region.toUpperCase()}`
      : lang.toLowerCase();
    const path = link.fields.link.value.href
      .toLowerCase()
      .replace(/^\/?([a-z]{2}(-[a-z]{2})?\/)?/, "");
    window.location.href = `/${prefix}/${path}`;
  };

  // Dropdown needs access to the DOM node in order to position the Menu
  const CustomToggle = React.forwardRef(({ children, onClick }, ref) => (
    <a
      href=""
      ref={ref}
      onClick={(e) => {
        e.preventDefault();
        onClick(e);
      }}
    >
      <div className="Utility-lang">
        <span className="headericon">
          <img
            src={
              children.image.value.src !== undefined
                ? `${configData.sitecoreApiHost}${children.image.value.src}`
                : OCIcon
            }
            alt={children.title.value}
          />
        </span>
      </div>
      <div className={"select-box--selected-item"}>
        <div className="select-box-selected-item-text-div">
          <span className={"select-box-selected-item-text"}>
            {children.title.value.toLowerCase()}
          </span>
        </div>
        <div className="select-box--arrow" name="select-box--name">
          <span
            name="drop-down-arrow"
            className="select-box--arrow-up fa fa-angle-down"
          ></span>
        </div>
      </div>
    </a>
  ));

  return (
    <div className="category-links">
      {links.map((link, index) => {
        return (
          <div key={index}>
            {link.fields.UtilityLaunchedLanguages.length > 1 ? (
              <>
                <div className="dropdown-wrap mb-md-3">
                  <div className="custom-select-dropdown">
                    <div className="select-box--box">
                      <div className="select-box--container">
                        <Dropdown>
                          <Dropdown.Toggle
                            as={CustomToggle}
                            id="dropdown-basic"
                          >
                            {link.fields}
                          </Dropdown.Toggle>
                          <Dropdown.Menu className="select-box--items">
                            {link.fields.UtilityLaunchedLanguages.map(
                              (item, index) => {
                                return (
                                  <div className="select-div" key={index}>
                                  <Dropdown.Item
                                    className="nameListItem"
                                    href="#"
                                    key={index}
                                    onClick={(event) => {
                                      event.preventDefault();
                                      event.stopPropagation();
                                      setLinkDetails(item, link);
                                    }}
                                  >
                                    {item.fields.Dictionary.value}
                                  </Dropdown.Item>
                                  </div>
                                );
                              },
                            )}
                          </Dropdown.Menu>
                        </Dropdown>
                      </div>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <a
                href={withLang(link.fields.link.value.href.toLowerCase())}
                id={link.id}
                key={link.id}
                className="utility-link"
                target={link.fields.link.value.target}
              >
                <span className="headericon">
                  <img
                    src={
                      link.fields.image.value.src !== undefined
                        ? `${configData.sitecoreApiHost}${link.fields.image.value.src}`
                        : OCIcon
                    }
                    alt={link.fields.title.value}
                  />
                </span>
                <span className="linklabel">{link.fields.title.value}</span>
              </a>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default LinksHome;
